<template>
  <div
    class="template-container_item mb-4"
  >
    <h2
      v-if="mode === 'Pick'"
      class="title-template-type mb-4 text-lg"
    >
      <span class="icon-template-type">
        <img :src="require('@/assets/images/icon/star.svg')"></span>
      {{ $i18nPresenter.t("AhaSlides Pick") }}
    </h2>
    <h2
      v-if="mode === 'Newly'"
      class="title-template-type mb-4 text-lg"
    >
      <span class="icon-template-type">
        <img :src="require('@/assets/images/icon/fire-alt.svg')"></span>{{ $i18nPresenter.t("Newly Added") }}
    </h2>
    <TemplateSliderSkeleton v-if="isLoading" />
    <div
      v-if="!isLoading && templates.length > 0"
    >
      <div v-if="mode === 'Pick'">
        <TemplateCardGlobal
          v-for="presentation in templates"
          :key="`mobile-template-admin-pick-${presentation.id}`"
          :presentation="presentation"
          class="template-library"
          where="AhaSlides Pick"
          templateLocation="template library"
        />
      </div>

      <div v-if="mode === 'Newly'">
        <TemplateCardGlobal
          v-for="presentation in templates"
          :key="`mobile-template-newly-added-${presentation.id}`"
          :presentation="presentation"
          class="template-library"
          where="Newly added"
          templateLocation="template library"
        />
      </div>
    </div>
    <div>
      <span
        v-if="!showMore"
        class="title-template-see-more"
        @click="seeMore"
      >
        {{ $i18nPresenter.t("See more") }}
      </span>
    </div>
  </div>
</template>
<script>
import TemplateCardGlobal from '@/components-v2/common/template-library/TemplateCardGlobal.vue'
import TemplateSliderSkeleton from '@/components-v2/template-library/TemplateSliderSkeleton.vue'

export default {
  components: {
    TemplateCardGlobal,
    TemplateSliderSkeleton,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: false,
    },
    templates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {
    seeMore() {
      this.$emit('showMoreClicked')
    },
  },
}
</script>
<style scoped lang='scss'>
.title-template-type {
  @apply flex mb-4 text-lg;
  .icon-template-type {
    margin-right: 9px;
  }
}
.title-template-see-more {
  margin-top: 4px;
  margin-bottom: 32px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #348EF6;
}
.template-container_item {
  @apply mb-5;
  .template-category-item {
    @apply mb-0;
  }
}
</style>
